const Mime = require('./Mime');

//import Mime from './Mime'

module.exports = new Mime(require('./types/standard'), require('./types/other'));

//const mime = new Mime(require('./types/standard'), require('./types/other'));

//export default mime